import { ClientService } from './../_services/Client.service';
import { IClient } from './../models/Client.model';
import { Component, OnInit } from "@angular/core";
import Swal from "sweetalert2";
import { UserService } from "../_services/user.service";

import { DomSanitizer } from "@angular/platform-browser";
declare var bootbox: any;
@Component({
  selector: "app-client",
  templateUrl: "./client.component.html",
  styleUrls: ["./client.component.css"],
})
export class ClientComponent implements OnInit {
  p: number = 1;
  searchTerm: string;
  searchTerm2: string;
  filterItems: any;
  clients: IClient[];
  avatar = "assets/img/avatars/user.png";
  items = [
    { id: 1, name: "Tel" },
    { id: 2, name: "Email" },
  ];
  selected = { id: 1, name: "Tel" };
  getValues() {
    console.log(this.selected);
    console.log(this.selected.name);
    if ((this.selected.name = "Email")) {
      this.showsearchType = !this.showsearchType;
    } else {
      this.showsearchType = !this.showsearchType;
    }
  }
  showsearchType = false;
  showSpinner: boolean = true;
  constructor(
    private clientservice: ClientService,
    private mesureservice: UserService,
    public sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    this.LoadTable();
    // this.getAllProfil();
     ///////
     var pageHeader = $(".content-header").find("b");
     var adminForm = $(".admin-form");
     var buttons = adminForm.find(".button");
     var Panel = adminForm.find(".panel");
     setTimeout(function () {
       adminForm.addClass("theme-success");
       Panel.addClass("panel-success");
       pageHeader.addClass("text-success");

       buttons.removeClass().addClass("button btn-success");
     }, 800);
     //////
  }
  LoadTable() {
    this.clientservice.getData().subscribe((data: IClient[]) => {
      this.clients = data;
      this.filterItems = this.clients;
      this.showSpinner = false;
    });
  }
  delete(id) {
    this.clientservice.deleteData(id).subscribe(() => {
      this.LoadTable();
    });
  }
  /* getAllProfil(){
    this.mesureservice.getData().subscribe(
      (data:MesureModel[])=>{
        this.mesures=data;

      }
    )
  } */

  setFileData($event, d) {
    this.getBase64($event, d);
  }
  deleteSupprimer(id) {
    Swal.fire({
      title: "Etes-vous sûre de vouloir supprimer?",
      showCancelButton: true,
    }).then((result) => {
      if (result.value) {
        this.delete(id);
        // handle Confirm button click
        // result.value will contain `true` or the input value
      } else {
        // handle dismissals
        // result.dismiss can be 'cancel', 'overlay', 'esc' or 'timer'
      }
    });
    /* Swal.fire({
       title: 'Êtes-vous sûr de vouloir supprimer.',
       text: "A revoir ...",
       type: 'warning',
       showCancelButton: true,
       confirmButtonColor: '#3085d6',
       cancelButtonColor: '#d33',
       confirmButtonText: 'Yes, delete it!'
     }).then((result) => {
       if (result.value) {
         this.delete(id);
         Swal.fire(
           'Supprimé!',
           'Supprimé avec succès',
           'success'
         )
       }else {

       }
     })*/
  }
  getBase64(event, client) {
    let me = this;
    let file = event.target.files[0];
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      console.log(reader.result);
      client.photo = reader.result;
      console.log(client);
    };
    reader.onerror = function (error) {
      console.log("Error: ", error);
    };
  }

  searchChanged() {
    this.filterItems = this.clients.filter((item) => {
      return item.tel.indexOf(this.searchTerm) > -1;
    });
  }

  searchEmail() {
    this.filterItems = this.clients.filter((item) => {
      return (
        item.user.email.toLowerCase().indexOf(this.searchTerm2.toLowerCase()) >
        -1
      );
    });
  }
}
